<template>
  <v-dialog v-model="open" persistent max-width="640px">
    <v-card>
      <form @submit.prevent="!isProcessing ? onSubmit() : null">
      <v-card-title>
          <span class="headline">Edycja typu</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0" grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Nazwa vouchera"
                  v-validate="'required'"
                  v-model="formData.name"
                  data-vv-name="Nazwa vouchera"
                  :error-messages="errors.collect('Nazwa vouchera')"
                  browser-autocomplete="off">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="$emit('close')">Anuluj</v-btn>
          <v-btn color="blue darken-1" :disabled="isProcessing" flat type="submit">Zapisz</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    props: {
      open: Boolean,
      formData: Object,
    },
    data() {
      return {
        isProcessing: false,
      };
    },
    name: 'EditVoucherType',
    methods: {
      ...mapActions('VoucherTypeStore', ['editVoucherType']),
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              this.editVoucherType({
                formData: {
                  name: this.formData.name,
                  numbering_pattern: this.formData.numbering_pattern,
                },
                id: this.formData.id,
              })
                .then(() => {
                  this.isProcessing = false;
                  this.$emit('close');
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>

<style scoped>

</style>
